export const isGroupedColumn = (column) => {
    return 'items' in column;
};
export const isGroupedRow = (row) => {
    return 'items' in row;
};
//# sourceMappingURL=SimpleTable.utils.js.map